import { render, staticRenderFns } from "./ResidentPaymentMethods.vue?vue&type=template&id=d83c8e7c&scoped=true&"
import script from "./ResidentPaymentMethods.vue?vue&type=script&lang=ts&"
export * from "./ResidentPaymentMethods.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentPaymentMethods.vue?vue&type=style&index=0&id=d83c8e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83c8e7c",
  null
  
)

export default component.exports